import Moment from "moment";

export default {
    getNumber(value) {
        const type = typeof (value)
        if (type === 'number' || type === 'string')
            return +value

        return null
    },

    getString(value) {
        if (typeof (value) === 'string' && value.length)
            return value

        return null
    },

    getBoolean(value) {
        if (typeof(value) === 'string') {
            if (value === 'true')
                return true
            else if (value === 'false')
                return false
        }

        return null
    },

    getArrayInt(value,splitter){
        const result = []
      if (typeof (value) === 'string' && value.length > 0)
          value = value.split(splitter)
        for (let i = 0; i <value.length ; i++) {
            result.push(Number.parseInt(value[i]))
        }

      return result
    },

    getMoment(value, format) {
        if (typeof(value) === 'string' && value.length === format.length)
            return Moment(value, format)
        return null
    }
}